import { getCLS, getLCP } from 'web-vitals';

const getExperienceConfig = () => window.__EXPERIENCE_PROPS__.expConfiguration || {};

let pollyCounter = 0;
const pollyTimeout = 3000;
const pollyRetries = 3;

const getQuantumMetricId = () => {

  pollyCounter += 1;

  const quantumMetricID = (
    typeof window.QuantumMetricAPI !== 'undefined'
    && typeof window.QuantumMetricAPI.getSessionID === 'function'
    && window.QuantumMetricAPI.getSessionID()
  ) || undefined;

  if (quantumMetricID) {
    window.newrelic.setCustomAttribute('quantumMetricId', quantumMetricID);
    return;
  }

  if (pollyCounter > pollyRetries) return;

  setTimeout(getQuantumMetricId, pollyTimeout);
};

function findDataComponent(firstNode, traverseCallback = () => { }) {
  const maxSteps = 10;
  let currentNode = firstNode;

  for (let i = 0; i < maxSteps; i += 1) {
    if (!currentNode) return null;

    const dataComponent = currentNode.attributes['data-component'];
    traverseCallback(i, currentNode);

    if (dataComponent) return dataComponent.value;

    currentNode = currentNode.parentElement;
  }

  return null;
}

export function performanceObserver() {

  const perfObserverEnabled = getExperienceConfig().PERFORMANCE_OBSERVER_ENABLED === 'true';

  if (!perfObserverEnabled) return;

  getCLS((info) => {
    if (!info || !info.value) return;

    window.newrelic.setCustomAttribute('CLS-value', info.value);
    const sourceClassNames = [];
    let worstOffender = null;

    if (Array.isArray(info.entries)) {
      info.entries.forEach((entry) => {
        if (Array.isArray(entry.sources)) {
          entry.sources.forEach((source) => sourceClassNames.push(source?.node?.className));
        }

        if (!worstOffender) {
          worstOffender = entry;
          return;
        }

        if (entry.value > worstOffender.value) {
          worstOffender = entry;
        }

      });

      window.newrelic.setCustomAttribute('CLS-Classnames', sourceClassNames.join(', '));
    }

    if (!worstOffender || !Array.isArray(worstOffender.sources)) return;

    const dataComponents = worstOffender.sources.reduce((acc, source) => {
      const dataComponent = findDataComponent(source?.node);
      if (dataComponent) acc.push(dataComponent);
      return acc;
    }, []);

    if (dataComponents.length) window.newrelic.setCustomAttribute('CLS-Components', dataComponents.join(', '));

  });

  getLCP((info) => {
    if (!info || !info.value) return;

    const { entries } = info;
    const entry = entries[0];
    const { url, element, renderTime, loadTime } = entry;
    const lcp = renderTime || loadTime;

    if (url) {
      window.newrelic.setCustomAttribute('LCP-url', url);
    }

    if (element) {
      const classNames = [];

      if (element.className) {
        classNames.push(element.className);
      }

      if (lcp) {
        window.newrelic.setCustomAttribute('LCP-value', lcp);
      }

      const dataComponent = findDataComponent(element,
        (index, currentNode) => {
          if (index < 3 && currentNode?.className) classNames.push(currentNode.className);
        }
      );

      window.newrelic.setCustomAttribute('LCP-Component', dataComponent);
      window.newrelic.setCustomAttribute('LCP-Classnames', classNames.join(', '));
    }

  });

  setTimeout(getQuantumMetricId, pollyTimeout);
}